import api from "../config/api";

export const getIncomeRebates = async (data) => {
  const res = await api.get("incomeRebate",data);
  return res.data;
};
